import createRoute from '@widesk-ui/tools/createRoute';
import PlaceModel  from '@models/website/PlaceModel';

const route = createRoute.dashboardFromModel(
	PlaceModel,
	'PlaceDashboard',
	{
		pathPrefix: '/website_entertainments/:websiteEntertainmentId',
	},
);
export default route;
